import("./bootstrap")
  .then(res => console.log("Loaded"))
  .catch(e => {
    document.getElementById("setup-errors-networks").classList.toggle("show");
  });